import { Typography } from '@mui/material';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateToMDYWithTime } from 'utils';
import { useAppointmentData } from '../../../stores/appointment/appointment.store';

export const PrivacyPolicyAcknowledgement: FC = () => {
  const { appointment } = useAppointmentData();
  const { t } = useTranslation();
  const appointmentStart = useMemo(() => formatDateToMDYWithTime(appointment?.start), [appointment?.start]);

  return (
    <Typography variant="body2" color="secondary.light">
      {t('telemed.review.patientInformation.privacyPolicy', {
        date: appointmentStart?.date,
        time: appointmentStart?.time,
      })}
    </Typography>
  );
};
